<template>
  <div>
    <b-field class="commonrules-grp" label=" Airline is not in the following list of preferred carriers ">
       <TagAutocomplete
         placeholder="e.g.Deutsche Bahn"
         icon="magnify"
         :chainData="airVendors"
         :selected="airPreferredVendors"
         @list="getSelectedAirVendors()"
         ></TagAutocomplete>
        </b-field>
   </div>
 </template>
  
  <script>
   import TagAutocomplete from '../../Tags/TagAutocomplete.vue';
    export default {
      name: "AirPreferredVendors",
      components: {
        TagAutocomplete
      },
      data() {
        return {
          airPreferredVendors:[]
        }
      },
      computed:{
        airVendors(){
           return Object.entries(this.$store.state.bookTravel.vendors.airlines);
        }
      },
        methods:{
          getSelectedAirVendors() {
            this.$emit('airPreferredVendors',this.airPreferredVendors);          
          }
      },
    }
  </script>

  <style scoped>
  </style>